export default {
    clear(){
        sessionStorage.clear();
    },
    setItem(chave,valor){
        sessionStorage.setItem(chave,valor);
    },
    setJsonItem(chave,valor){
        sessionStorage.setItem(chave,JSON.stringify(valor));
    },
    getCurrentParticipante(){
        return this.getJsonItem('LU');
    },
    getJsonItem(chave){
        let item = sessionStorage.getItem(chave);
        try{
            if(item){
                item = JSON.parse(item);
                return item;
            }
        }catch(err){}

    
        return '';
    },
    getItem(chave){
        const item = sessionStorage.getItem(chave);
        if(item) return item;
        return '';
    },
    removeItem(chave){
        sessionStorage.removeItem(chave);
    },
    
}


// WEBPACK FOOTER //
// ./src/services/storageService.js